/* PES Collection UI v6 — Sidebar Fix + Enhanced Filters */
(function(){'use strict';

/* ========== SORT DROPDOWN ========== */
var sortLabels={
'best-selling':'Best Selling',
'price-ascending':'Price: Low to High',
'price-descending':'Price: High to Low',
'title-ascending':'Name: A to Z',
'title-descending':'Name: Z to A',
'created-ascending':'Date: Old to New',
'created-descending':'Date: New to Old',
'manual':'Featured'
};

function initSortDropdown(){
var existing=document.getElementById('pes-sort-select');
if(existing)return;
var toolbar=document.querySelector('.facets-vertical-sort, .collection-toolbar, .product-grid-container, .custm-mn-topslder');
if(!toolbar)return;
var sortWrap=document.createElement('div');
sortWrap.className='pes-sort-wrap';
sortWrap.style.cssText='display:flex;align-items:center;gap:8px;margin:0 0 0 auto;';
var label=document.createElement('span');
label.className='pes-sort-label';
label.textContent='Sort:';
label.style.cssText='font-size:13px;color:#666;font-weight:500;';
var select=document.createElement('select');
select.id='pes-sort-select';
select.className='pes-sort-select';
select.style.cssText='padding:6px 28px 6px 12px;border:1px solid #ddd;border-radius:6px;font-size:14px;background:#fff;color:#333;cursor:pointer;';
var currentSort=new URLSearchParams(window.location.search).get('sort_by')||'best-selling';
Object.keys(sortLabels).forEach(function(key){
var opt=document.createElement('option');
opt.value=key;
opt.textContent=sortLabels[key];
if(key===currentSort)opt.selected=true;
select.appendChild(opt);
});
select.addEventListener('change',function(){
var url=new URL(window.location.href);
url.searchParams.set('sort_by',select.value);
window.location.href=url.toString();
});
sortWrap.appendChild(label);
sortWrap.appendChild(select);
var targetEl=toolbar.querySelector('.facets-vertical-sort, .facet-filters__sort');
if(targetEl){targetEl.appendChild(sortWrap);}
else{toolbar.insertBefore(sortWrap,toolbar.firstChild);}
}

/* ========== CSS INJECTION ========== */
var css=`
/* === LAYOUT FIX: Show sidebar as left column === */
.cust-desktop-sortfilter{
  display:block!important;
  width:260px!important;
  min-width:260px!important;
  flex-shrink:0!important;
  position:sticky!important;
  top:80px!important;
  max-height:calc(100vh - 100px)!important;
  overflow-y:auto!important;
  padding-right:8px;
}
.cstm-collect-facets-container.facets-vertical{
  display:flex!important;
  gap:24px!important;
  align-items:flex-start!important;
}
.collection_main_grid{
  flex:1!important;
  min-width:0!important;
}
/* Hide native sort (we have our own) */
.facet-filters.sorting,
.cust-desktop-sortfilter .facet-filters__sort,
.cust-desktop-sortfilter .select,
#SortBy,
#FacetSortForm{
  display:none!important;
}
/* Hide native facet checkboxes */
.facet-checkbox{display:none!important}

/* === SIDEBAR STYLING === */
.pes-sidebar{
  background:#fff;
  border:1px solid #e5e5e5;
  border-radius:8px;
  padding:0 16px 16px;
}
.pes-sidebar-title{
  font-size:16px;
  font-weight:700;
  color:#0f1e2d;
  margin:0;
  padding:16px 0 12px;
  border-bottom:2px solid #11B67B;
  display:flex;
  align-items:center;
  justify-content:space-between;
}
.pes-sidebar-title span{font-size:12px;color:#999;font-weight:400;}
.pes-filter-group{
  border-bottom:1px solid #eee;
  padding:12px 0;
}
.pes-filter-group:last-child{border-bottom:none;}
.pes-filter-group-header{
  font-size:13px;
  font-weight:700;
  text-transform:uppercase;
  letter-spacing:.5px;
  color:#333;
  margin:0 0 8px;
  cursor:pointer;
  display:flex;
  justify-content:space-between;
  align-items:center;
  user-select:none;
}
.pes-filter-group-header .toggle{
  width:20px;
  height:20px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:16px;
  color:#999;
  transition:transform .2s;
}
.pes-filter-group.collapsed .toggle{transform:rotate(-90deg);}
.pes-filter-group.collapsed .pes-filter-list{display:none;}
.pes-filter-list{
  list-style:none;
  padding:0;
  margin:0;
}
.pes-filter-list li{margin-bottom:2px;}
.pes-filter-list a{
  font-size:13px;
  color:#555;
  text-decoration:none;
  padding:6px 8px;
  display:block;
  border-radius:4px;
  transition:all .15s;
  position:relative;
  text-transform:capitalize; /* PES 2026-08-09: raw vendor values arrive lowercase ("anker solix") */
}
.pes-filter-list a:hover{
  background:#f5f5f5;
  color:#11B67B;
}
.pes-filter-list a.active{
  background:#e8f7f0;
  color:#11B67B;
  font-weight:600;
}
.pes-filter-list a .count{
  font-size:11px;
  color:#999;
  margin-left:4px;
}

/* === ACTIVE FILTER CHIPS === */
.pes-active-filters{
  display:flex;
  flex-wrap:wrap;
  gap:6px;
  margin-bottom:12px;
  padding-top:8px;
}
.pes-filter-chip{
  background:#11B67B;
  color:#fff;
  padding:4px 10px;
  border-radius:12px;
  font-size:12px;
  font-weight:500;
  display:inline-flex;
  align-items:center;
  gap:4px;
  cursor:pointer;
  text-decoration:none;
  border:none;
  text-transform:capitalize;
}
.pes-filter-chip:hover{background:#0d9460;}
.pes-filter-chip .x{font-size:14px;margin-left:2px;font-weight:700;}
.pes-clear-all{
  font-size:12px;
  color:#999;
  text-decoration:underline;
  cursor:pointer;
  background:none;
  border:none;
  padding:4px 8px;
}

/* === PRICE SLIDER === */
.pes-price-inputs{
  display:flex;
  align-items:center;
  gap:8px;
  margin-top:8px;
}
.pes-price-inputs input{
  width:80px;
  padding:6px 8px;
  border:1px solid #ddd;
  border-radius:4px;
  font-size:13px;
}
.pes-price-inputs .sep{color:#999;font-size:13px;}
.pes-price-go{
  padding:6px 12px;
  background:#11B67B;
  color:#fff;
  border:none;
  border-radius:4px;
  font-size:13px;
  cursor:pointer;
  font-weight:600;
}
.pes-price-go:hover{background:#0d9460;}

/* === BROWSE BUBBLE HIDE === */
.pes-browse-bubble,.browse-collection-bubble,[class*="browse"][class*="bubble"],
.browse-all-categories,[class*="Browse this collection"]{display:none!important}
a[href*="browse"][class*="bubble"]{display:none!important}
.custm-mn-topslder .mblfitlers a[href*="browse"]{display:none!important}

/* === MOBILE (defer entirely to pes-collection-filters.js drawer, breakpoint 989px) === */
@media(max-width:989px){
  .cust-desktop-sortfilter{
    display:none!important;
  }
}

/* === MOBILE BOTTOM-SHEET FILTERS (<=768px) — owned by this script (Agent-8, Task B) ===
   Supersedes the legacy side drawer from pes-collection-filters.js at <=768px only;
   769-989px still uses the legacy drawer. */
.pes-bs-bar{display:none;}
@media(max-width:768px){
  .pes-mobile-filter-bar,.pes-filter-drawer,.pes-filter-overlay{display:none!important;}
  .pes-bs-bar{display:flex!important;margin:0 0 12px;padding:0 4px;}
}
.pes-bs-btn{display:inline-flex;align-items:center;gap:8px;background:#0f1e2d;color:#fff;border:none;border-radius:8px;padding:10px 16px;font-size:14px;font-weight:700;cursor:pointer;font-family:inherit;}
.pes-bs-btn svg{width:16px;height:16px;flex-shrink:0;}
.pes-bs-badge{background:#11B67B;color:#fff;font-size:11px;font-weight:800;min-width:18px;height:18px;border-radius:9px;display:inline-flex;align-items:center;justify-content:center;padding:0 5px;}
.pes-bs-scrim{position:fixed;inset:0;background:rgba(15,30,45,0.55);z-index:10001;opacity:0;pointer-events:none;transition:opacity .25s;}
.pes-bs-scrim.open{opacity:1;pointer-events:auto;}
.pes-bs-sheet{position:fixed;left:0;right:0;bottom:0;z-index:10002;background:#fff;border-radius:16px 16px 0 0;max-height:84vh;display:flex;flex-direction:column;transform:translateY(103%);visibility:hidden;transition:transform .3s ease,visibility 0s linear .3s;box-shadow:0 -12px 40px rgba(0,0,0,0.3);}
.pes-bs-sheet.open{transform:translateY(0);visibility:visible;transition:transform .3s ease;}
.pes-bs-head{display:flex;align-items:center;justify-content:space-between;padding:14px 18px;border-bottom:1px solid #eee;flex:0 0 auto;}
.pes-bs-head h2{font-size:16px;font-weight:800;color:#0f1e2d;margin:0;}
.pes-bs-close{background:none;border:none;font-size:26px;line-height:1;cursor:pointer;color:#666;padding:2px 8px;}
.pes-bs-body{overflow-y:auto;-webkit-overflow-scrolling:touch;padding:8px 18px 18px;flex:1 1 auto;}
.pes-bs-group{padding:10px 0;border-bottom:1px solid #eee;}
.pes-bs-group:last-child{border-bottom:none;}
.pes-bs-group-name{font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.6px;color:#333;margin:0 0 8px;}
.pes-bs-list{list-style:none;margin:0;padding:0;}
.pes-bs-list li{margin-bottom:2px;}
.pes-bs-opt{display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;background:none;border:none;text-align:left;font-size:15px;color:#444;padding:10px;border-radius:8px;cursor:pointer;font-family:inherit;text-transform:capitalize;}
.pes-bs-opt .cnt{font-size:12px;color:#999;font-weight:400;}
.pes-bs-opt.selected{background:#e8f7f0;color:#11B67B;font-weight:700;}
.pes-bs-opt.selected .cnt{color:#0d9a68;}
.pes-bs-price-inputs{display:flex;align-items:center;gap:8px;padding:6px 0 2px;}
.pes-bs-price-inputs input{flex:1;min-width:0;padding:9px 10px;border:1px solid #ddd;border-radius:6px;font-size:14px;}
.pes-bs-price-inputs .sep{color:#999;font-size:13px;}
.pes-bs-foot{display:flex;gap:10px;padding:14px 18px;border-top:1px solid #eee;flex:0 0 auto;}
.pes-bs-clear{flex:1;background:#fff;border:1px solid #ddd;border-radius:8px;padding:12px;font-size:14px;font-weight:700;color:#555;cursor:pointer;font-family:inherit;}
.pes-bs-apply{flex:2;background:#11B67B;border:none;border-radius:8px;padding:12px;font-size:14px;font-weight:800;color:#fff;cursor:pointer;font-family:inherit;}
.pes-bs-apply:hover{background:#0d9460;}
@media(min-width:769px){
  .pes-bs-bar,.pes-bs-scrim,.pes-bs-sheet{display:none!important;}
}
body.pes-bs-locked{overflow:hidden;}
`;

function injectCSS(){
if(document.getElementById('pes-v6-css'))return;
var style=document.createElement('style');
style.id='pes-v6-css';
style.textContent=css;
document.head.appendChild(style);
}

/* ========== ENHANCED FILTER SIDEBAR ========== */
function buildSidebar(){
var container=document.querySelector('.facets-container')||document.querySelector('.cust-desktop-sortfilter');
if(!container)return;
// Remove old fallback filters
var old=container.querySelector('.pes-fallback-filters, .pes-sidebar');
if(old)old.remove();

var m=window.location.pathname.match(/\/collections\/([^\/\?]+)/);
if(!m)return;
var handle=m[1];

// Get current URL params for active filter detection
var params=new URLSearchParams(window.location.search);
var activePriceGte=params.get('filter.v.price.gte');
var activePriceLte=params.get('filter.v.price.lte');

// Dynamic per-collection filter config (2026-08-04 rework)
// Replaces the hardcoded 7-collection map: vendors + product types are
// computed live from the collection's own products, so every one of the
// 300+ collections gets accurate Brand/Type groups automatically.
var priceMap={
'solar-panels':[['Under $150',null,'150'],['$150 – $250','150','250'],['$250 – $350','250','350'],['$350 – $500','350','500'],['$500+','500',null]],
'inverters':[['Under $500',null,'500'],['$500 – $1,000','500','1000'],['$1,000 – $2,000','1000','2000'],['$2,000 – $5,000','2000','5000'],['$5,000+','5000',null]],
'batteries-energy-storage':[['Under $1,000',null,'1000'],['$1,000 – $3,000','1000','3000'],['$3,000 – $5,000','3000','5000'],['$5,000 – $10,000','5000','10000'],['$10,000+','10000',null]],
'charge-controllers':[['Under $100',null,'100'],['$100 – $300','100','300'],['$300 – $500','300','500'],['$500+','500',null]],
'racking-mounting':[['Under $50',null,'50'],['$50 – $150','50','150'],['$150 – $500','150','500'],['$500+','500',null]],
'electrical-supplies':[['Under $25',null,'25'],['$25 – $100','25','100'],['$100 – $500','100','500'],['$500+','500',null]],
'commercial-standby-generators':[['Under $2,000',null,'2000'],['$2,000 – $5,000','2000','5000'],['$5,000 – $10,000','5000','10000'],['$10,000+','10000',null]],
'generators':[['Under $2,000',null,'2000'],['$2,000 – $5,000','2000','5000'],['$5,000 – $10,000','5000','10000'],['$10,000+','10000',null]],
'ev-chargers':[['Under $300',null,'300'],['$300 – $600','300','600'],['$600 – $1,000','600','1000'],['$1,000+','1000',null]]
};
var defaultPrices=[['Under $250',null,'250'],['$250 – $500','250','500'],['$500 – $1,000','500','1000'],['$1,000+','1000',null]];

function priceBuckets(h){
var rows=priceMap[h]||defaultPrices;
return rows.map(function(r){return {label:r[0],gte:r[1],lte:r[2]};});
}

function baseGroups(h){
return [
{name:'Price Range',type:'price',values:priceBuckets(h)},
{name:'Availability',type:'availability',values:[{label:'Available Only',param:'filter.v.availability',value:'1'}]}
];
}

var sidebarInflight=false;
/* PES 2026-08-09 brand/attribute facet overhaul (shared by config builder + renderers):
   - placeholder vendors (PES Supply / PES Global / ENF Solar) are NOT brands -> excluded from Brand facet
   - vendor case variants merged into one canonical brand with a multi-value filter link
   - Technology facet from product tags; Wattage facet links to wattage collections */
var JUNK_VENDORS={'pes supply':1,'pes global':1,'pes global group':1,'pes':1,'pes system kits':1,'pes system kit':1,'outbound':1,'outbound brands':1,'enf solar':1,'portlandia electric supply':1,'portlandia electric':1,'':1,'unknown':1,'n/a':1};
var BRAND_DISPLAY={'anker solix':'Anker SOLIX','ecoflow':'EcoFlow','goodwe':'GoodWe','eg4':'EG4','eg4 electronics':'EG4','apsystems':'APsystems','enphase':'Enphase','solaredge':'SolarEdge','ja solar':'JA Solar','longi':'LONGi','znshine':'ZNShine','znshine solar':'ZNShine','qcells':'Qcells','rec':'REC','sma':'SMA','k2':'K2 Solar Systems','k2 solar systems':'K2 Solar Systems','midnite solar':'MidNite Solar','midnite':'MidNite Solar','victron energy':'Victron Energy','victron':'Victron Energy','silfab':'Silfab','silfab solar':'Silfab','trina solar':'Trina Solar','canadian solar':'Canadian Solar','philadelphia solar':'Philadelphia Solar','mission solar':'Mission Solar','jinko':'Jinko','jinko solar':'Jinko','hyundai':'Hyundai','hyundai energy solutions':'Hyundai','westinghouse':'Westinghouse','generac':'Generac','duromax':'DuroMax','kohler':'Kohler','cummins':'Cummins','briggs & stratton':'Briggs & Stratton','jackery':'Jackery','bluetti':'Bluetti','outback power':'Outback Power','ironridge':'IronRidge','quick mount pv':'Quick Mount PV','unirac':'Unirac','thornova':'Thornova Solar','thornova solar':'Thornova Solar','talesun':'Talesun','talesun solar':'Talesun','aptos solar':'Aptos Solar','vsun':'VSUN','phono solar':'Phono Solar','runergy':'Runergy','samlex':'Samlex','cotek':'COTEK','magnum':'Magnum Energy','magnum energy':'Magnum Energy','schneider':'Schneider Electric','schneider electric':'Schneider Electric','schneider conext':'Schneider Electric','xuri solar':'Xuri Solar','zenithsun':'ZenithSun','topsky energy':'Topsky Energy','tpl solar':'TPL Solar','vds renewable':'VDS Renewable','wit solar':'WIT Solar','voxery':'Voxery','terrasolar':'TerraSolar','solarspace':'SolarSpace','hanersun':'HanerSun','resun':'Resun','seraphim':'Seraphim','wallbox':'Wallbox','fronius':'Fronius','growatt':'Growatt','sol-ark':'Sol-Ark','sol ark':'Sol-Ark','solaria':'Solaria','meyer burger':'Meyer Burger','peimar':'Peimar','astronergy':'Astronergy','newpowa':'Newpowa'};
function titleCase(s){return s.replace(/\w\S*/g,function(w){return w.charAt(0).toUpperCase()+w.substr(1);});}
function canonBrand(v){var k=(v||'').toLowerCase().trim().replace(/\s+/g,' ');return BRAND_DISPLAY[k]||titleCase(k);}
var TECH_MAP={'bifacial':'Bifacial','topcon':'TOPCon','topcon-n-type':'TOPCon','hjt':'HJT','perc':'PERC','half-cut':'Half-Cut','half-cell':'Half-Cut','monocrystalline':'Mono','monofacial':'Mono','n-type':'N-Type'};
var WATT_COLLS={'300':1,'330':1,'350':1,'370':1,'400':1,'410':1,'420':1,'430':1,'440':1,'450':1,'455':1,'460':1,'465':1,'470':1,'475':1,'480':1,'500':1,'540':1,'550':1,'560':1,'600':1,'650':1,'700':1};
function withConfig(h,cb){
if(sidebarInflight)return;
sidebarInflight=true;
var cacheKey='pes-fc5-'+h;
try{
var cached=localStorage.getItem(cacheKey);
if(cached){sidebarInflight=false;cb(JSON.parse(cached));return;}
}catch(e){}
fetch('/collections/'+h+'/products.json?limit=250')
.then(function(r){return r.ok?r.json():{products:[]};})
.then(function(d){
sidebarInflight=false;
var prods=d.products||[];
var vendorGroups={},typeCounts={},facetData=[],techGroups={},wattSeen={};
prods.forEach(function(p){
var rawV=(p.vendor||'').trim();
var vk=rawV.toLowerCase().replace(/\s+/g,' ');
var brand=null;
if(!JUNK_VENDORS[vk]){
brand=canonBrand(rawV);
if(!vendorGroups[brand])vendorGroups[brand]={brand:brand,raw:[],count:0};
if(vendorGroups[brand].raw.indexOf(rawV)<0)vendorGroups[brand].raw.push(rawV);
vendorGroups[brand].count++;
}
if(p.product_type)typeCounts[p.product_type]=(typeCounts[p.product_type]||0)+1;
var tags=(p.tags||[]).map(function(t){return String(t);});
var tagsLower=tags.map(function(t){return t.toLowerCase().trim();});
var techLabels={};
tags.forEach(function(t,ti){
var label=TECH_MAP[tagsLower[ti]];
if(label&&!techLabels[label]){
techLabels[label]=1;
if(!techGroups[label])techGroups[label]={label:label,raw:[],rawl:[],count:0};
if(techGroups[label].rawl.indexOf(tagsLower[ti])<0){techGroups[label].raw.push(t);techGroups[label].rawl.push(tagsLower[ti]);}
techGroups[label].count++;
}
});
var wm=(p.title||'').match(/(\d{2,4})\s*[wW](?:att)?\b/);
var watt=0;
if(wm){var cw=parseInt(wm[1],10);if(cw>=100&&cw<=800)watt=cw;}
if(watt)wattSeen[watt]=(wattSeen[watt]||0)+1;
var price=null,avail=false;
(p.variants||[]).forEach(function(v){
var pr=parseFloat(v.price);
if(!isNaN(pr)&&(price===null||pr<price))price=pr;
if(v.available)avail=true;
});
facetData.push({v:rawV,brand:brand,t:p.product_type||'',p:price,a:avail,tags:tagsLower,w:watt});
});
var groups=[];
var isWattColl=/^\d{3}w-/.test(h);
var isPanelColl=isWattColl||h.indexOf('solar-panel')>=0;
var brands=Object.keys(vendorGroups).map(function(k){return vendorGroups[k];}).sort(function(a,b){return b.count-a.count;}).slice(0,14);
if(brands.length)groups.push({name:'Brand',type:'vendorgroup',values:brands});
if(isPanelColl){
var techs=Object.keys(techGroups).map(function(k){return techGroups[k];}).sort(function(a,b){return b.count-a.count;});
if(techs.length>1)groups.push({name:'Technology',type:'tagfilter',values:techs});
var watts=Object.keys(wattSeen).map(function(w){return parseInt(w,10);}).filter(function(w){return WATT_COLLS[w];}).sort(function(a,b){return a-b;});
if(!isWattColl&&watts.length>1)groups.push({name:'Wattage',type:'nav',values:watts.map(function(w){return {label:w+'W',url:'/collections/'+w+'w-solar-panels',count:wattSeen[w]};})});
}
var types=Object.keys(typeCounts).sort(function(a,b){return typeCounts[b]-typeCounts[a];}).slice(0,10);
if(types.length>1)groups.push({name:'Type',type:'product_type',values:types});
groups=groups.concat(baseGroups(h));
var config={groups:groups,facetData:facetData};
try{localStorage.setItem(cacheKey,JSON.stringify(config));}catch(e){}
cb(config);
})
.catch(function(){
sidebarInflight=false;
cb({groups:baseGroups(h),facetData:[]});
});
}

withConfig(handle,function(config){
if(!config)return;
/* === FACET COUNTS (Task C) — sibling-filter-aware ===
   Counts are computed client-side from the collection's products.json rows
   (first 250 products). Each group's counts respect the currently-applied
   filters from the OTHER groups (standard faceted-search behavior). */
var activeType=params.get('filter.p.product_type');
var activeVendors=params.getAll('filter.p.vendor');
var activeTags=params.getAll('filter.p.tag').map(function(t){return t.toLowerCase();});
var availActive=params.get('filter.v.availability')==='1';
var fd=config.facetData||[];
function escHtml(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
function passes(p,exclude){
if(exclude!=='vendor'&&activeVendors.length&&activeVendors.indexOf(p.v)<0)return false;
if(exclude!=='tag'&&activeTags.length){
var hit=false;
for(var ti=0;ti<activeTags.length;ti++){if(p.tags&&p.tags.indexOf(activeTags[ti])>=0){hit=true;break;}}
if(!hit)return false;
}
if(exclude!=='type'&&activeType&&p.t!==activeType)return false;
if(exclude!=='price'){
if(activePriceGte&&(p.p===null||p.p<parseFloat(activePriceGte)))return false;
if(activePriceLte&&(p.p===null||p.p>parseFloat(activePriceLte)))return false;
}
if(exclude!=='availability'&&availActive&&!p.a)return false;
return true;
}
function facetCount(fn,exclude){
if(!fd.length)return -1;
var n=0;fd.forEach(function(p){if(fn(p)&&passes(p,exclude))n++;});
return n;
}
function countHtml(n){return n>=0?' <span class="count">('+n+')</span>':'';}

// Build sidebar HTML
var html='<div class="pes-sidebar">';
html+='<h3 class="pes-sidebar-title">Filters <span>Refine</span></h3>';

// Active filter chips
var hasActive=activeVendors.length||activeTags.length||activePriceGte||activePriceLte||params.get('filter.v.availability')||params.get('filter.p.product_type');
if(hasActive){
html+='<div class="pes-active-filters">';
activeVendors.forEach(function(av){
html+='<a class="pes-filter-chip" href="'+clearParam('filter.p.vendor')+'">'+escHtml(canonBrand(av))+' <span class="x">×</span></a>';
});
params.getAll('filter.p.tag').forEach(function(at){
html+='<a class="pes-filter-chip" href="'+clearParam('filter.p.tag')+'">'+escHtml(at)+' <span class="x">×</span></a>';
});
if(activePriceGte||activePriceLte){
var plabel='';
if(activePriceGte&&activePriceLte)plabel='$'+activePriceGte+'–$'+activePriceLte;
else if(activePriceGte)plabel='$'+activePriceGte+'+';
else plabel='Under $'+activePriceLte;
html+='<a class="pes-filter-chip" href="'+clearParams(['filter.v.price.gte','filter.v.price.lte'])+'">'+plabel+' <span class="x">×</span></a>';
}
if(params.get('filter.p.product_type')){
html+='<a class="pes-filter-chip" href="'+clearParam('filter.p.product_type')+'">'+params.get('filter.p.product_type')+' <span class="x">×</span></a>';
}
if(params.get('filter.v.availability')){
html+='<a class="pes-filter-chip" href="'+clearParam('filter.v.availability')+'">Available <span class="x">×</span></a>';
}
html+='<a class="pes-clear-all" href="/collections/'+handle+'">Clear All</a>';
html+='</div>';
}

// Filter groups
config.groups.forEach(function(group,gi){
html+='<div class="pes-filter-group'+(gi>2?' collapsed':'')+'" data-group="'+gi+'">';
html+='<div class="pes-filter-group-header">'+group.name+'<span class="toggle">▾</span></div>';
html+='<ul class="pes-filter-list">';

if(group.type==='vendorgroup'){
group.values.forEach(function(g){
var qs=g.raw.map(function(r){return 'filter.p.vendor='+encodeURIComponent(r);}).join('&');
var u='/collections/'+handle+'?'+qs;
var isActive=g.raw.some(function(r){return activeVendors.indexOf(r)>=0;});
var n=facetCount(function(p){return p.brand===g.brand;},'vendor');
html+='<li><a href="'+u+'"'+(isActive?' class="active"':'')+'>'+escHtml(g.brand)+countHtml(n)+'</a></li>';
});
}else if(group.type==='tagfilter'){
group.values.forEach(function(g){
var qs=g.raw.map(function(r){return 'filter.p.tag='+encodeURIComponent(r);}).join('&');
var u='/collections/'+handle+'?'+qs;
var isActive=g.rawl.some(function(r){return activeTags.indexOf(r)>=0;});
var n=facetCount(function(p){
var hit=false;
for(var ri=0;ri<g.rawl.length;ri++){if(p.tags.indexOf(g.rawl[ri])>=0){hit=true;break;}}
return hit;
},'tag');
html+='<li><a href="'+u+'"'+(isActive?' class="active"':'')+'>'+escHtml(g.label)+countHtml(n)+'</a></li>';
});
}else if(group.type==='nav'){
group.values.forEach(function(g){
html+='<li><a href="'+g.url+'">'+escHtml(g.label)+(g.count>=0?' <span class="count">('+g.count+')</span>':'')+'</a></li>';
});
}else if(group.type==='vendor'){
group.values.forEach(function(vendor){
var u='/collections/'+handle+'?filter.p.vendor='+encodeURIComponent(vendor);
var isActive=activeVendors.indexOf(vendor)>=0;
var n=facetCount(function(p){return p.v===vendor;},'vendor');
html+='<li><a href="'+u+'"'+(isActive?' class="active"':'')+'>'+escHtml(vendor)+countHtml(n)+'</a></li>';
});
}else if(group.type==='price'){
group.values.forEach(function(pv){
var params2=new URLSearchParams();
if(pv.gte)params2.set('filter.v.price.gte',pv.gte);
if(pv.lte)params2.set('filter.v.price.lte',pv.lte);
var u='/collections/'+handle+'?'+params2.toString();
var n=facetCount(function(p){
if(p.p===null)return false;
if(pv.gte&&p.p<parseFloat(pv.gte))return false;
if(pv.lte&&p.p>parseFloat(pv.lte))return false;
return true;
},'price');
html+='<li><a href="'+u+'">'+pv.label+countHtml(n)+'</a></li>';
});
// Price input fields
html+='<li><div class="pes-price-inputs">';
html+='<input type="number" id="pes-price-min" placeholder="$ Min" aria-label="Minimum price" value="'+(activePriceGte||'')+'">';
html+='<span class="sep">–</span>';
html+='<input type="number" id="pes-price-max" placeholder="$ Max" aria-label="Maximum price" value="'+(activePriceLte||'')+'">';
html+='<button class="pes-price-go" onclick="var u=new URL(window.location.href);var mn=document.getElementById(\'pes-price-min\').value;var mx=document.getElementById(\'pes-price-max\').value;if(mn)u.searchParams.set(\'filter.v.price.gte\',mn);else u.searchParams.delete(\'filter.v.price.gte\');if(mx)u.searchParams.set(\'filter.v.price.lte\',mx);else u.searchParams.delete(\'filter.v.price.lte\');window.location.href=u.toString();">Go</button>';
html+='</div></li>';
}else if(group.type==='availability'){
group.values.forEach(function(av){
var u='/collections/'+handle+'?'+av.param+'='+av.value;
var isActive=params.get(av.param)===av.value;
var n=facetCount(function(p){return p.a;},'availability');
html+='<li><a href="'+u+'"'+(isActive?' class="active"':'')+'>'+av.label+countHtml(n)+'</a></li>';
});
}else if(group.type==='product_type'){
group.values.forEach(function(t){
var u='/collections/'+handle+'?filter.p.product_type='+encodeURIComponent(t);
var isActive=activeType===t;
var n=facetCount(function(p){return p.t===t;},'type');
html+='<li><a href="'+u+'"'+(isActive?' class="active"':'')+'>'+escHtml(t)+countHtml(n)+'</a></li>';
});
}else if(group.type==='tag'){
group.values.forEach(function(tv){
var u='/collections/'+handle+'/'+tv.tag;
html+='<li><a href="'+u+'">'+tv.label+'</a></li>';
});
}

html+='</ul>';
html+='</div>';
});

html+='</div>';

// Inject into container. Freeze the box at its current height during the swap
// so the legacy-facets -> pes-sidebar rebuild does not shift visible layout
// (CLS 0.37 cold-path fix, 2026-08-08). Released after two frames; content
// below the sidebar is below the fold so the release shift is not scored.
var frozenH=container.offsetHeight;
if(frozenH>0)container.style.minHeight=frozenH+'px';
container.innerHTML=html;
container.style.padding='0';
requestAnimationFrame(function(){requestAnimationFrame(function(){
container.style.minHeight='auto';
});});

// Add accordion toggle
container.querySelectorAll('.pes-filter-group-header').forEach(function(header){
header.addEventListener('click',function(){
var group=header.parentElement;
group.classList.toggle('collapsed');
});
});
// Mobile bottom-sheet filters (<=768px) — presentation shell reusing the same config + URL state (Task B).
// 769-989px remains owned by the legacy pes-collection-filters.js drawer.
buildFilterSheet(config,handle,{
activeVendors:activeVendors,activeTags:activeTags,activeType:activeType,
activePriceGte:activePriceGte,activePriceLte:activePriceLte,
availActive:availActive,facetCount:facetCount,escHtml:escHtml
});
});}

/* ========== MOBILE BOTTOM-SHEET FILTERS (<=768px, Task B) ========== */
/* ERR-025 fix: a real facets container holds filter inputs; the /search header
   shares the class but contains none — never anchor/flex that one. */
function findFacetsContainer(){
// ERR-025: search results render THREE .cstm-collect-facets-container nodes;
// .template-search__header is the impostor header strip, never anchor there.
// The real filter sidebar is .facets-vertical on both PLP and search.
var all=document.querySelectorAll('.cstm-collect-facets-container');
var keep=[];
for(var i=0;i<all.length;i++){
if(all[i].classList.contains('template-search__header'))continue;
keep.push(all[i]);
}
for(var j=0;j<keep.length;j++){
if(keep[j].classList.contains('facets-vertical'))return keep[j];
}
return keep.length?keep[0]:null;
}
function buildFilterSheet(config,handle,ctx){
if(!config||!config.groups)return;
// Don't rebuild while the shopper has the sheet open (init() re-runs on timers)
var existing=document.getElementById('pes-bs-sheet');
if(existing&&existing.classList.contains('open'))return;
var anchor=findFacetsContainer();
if(!anchor)return;
var oldBar=document.getElementById('pes-bs-bar');if(oldBar)oldBar.remove();
var oldScrim=document.getElementById('pes-bs-scrim');if(oldScrim)oldScrim.remove();
if(existing)existing.remove();

var esc=ctx.escHtml;
var activeVendorsArr=ctx.activeVendors||[];
var activeTagsArr=ctx.activeTags||[];
// Active-count badge: one per active filter dimension
var activeCount=0;
if(activeVendorsArr.length)activeCount++;
if(activeTagsArr.length)activeCount++;
if(ctx.activeType)activeCount++;
if(ctx.activePriceGte||ctx.activePriceLte)activeCount++;
if(ctx.availActive)activeCount++;

// Staged selection (single-select per group, mirroring the desktop link model)
var staged={
vendorQs:null,
tagQs:null,
type:ctx.activeType||null,
avail:ctx.availActive||false
};

/* --- Trigger bar --- */
var bar=document.createElement('div');
bar.className='pes-bs-bar';bar.id='pes-bs-bar';
bar.innerHTML='<button type="button" class="pes-bs-btn" id="pes-bs-open" aria-haspopup="dialog">'
+'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line></svg>'
+'<span>Filters</span>'
+(activeCount?'<span class="pes-bs-badge" aria-label="'+activeCount+' active filters">'+activeCount+'</span>':'')
+'</button>';
anchor.parentNode.insertBefore(bar,anchor);

/* --- Sheet markup --- */
var h='<div class="pes-bs-head"><h2>Filters</h2>'
+'<button type="button" class="pes-bs-close" aria-label="Close filters">&times;</button></div>';
h+='<div class="pes-bs-body">';
config.groups.forEach(function(group){
h+='<div class="pes-bs-group">';
h+='<div class="pes-bs-group-name">'+esc(group.name)+'</div>';
h+='<ul class="pes-bs-list">';
if(group.type==='vendorgroup'){
group.values.forEach(function(g){
var qs=g.raw.map(function(r){return 'filter.p.vendor='+encodeURIComponent(r);}).join('&');
var sel=g.raw.some(function(r){return activeVendorsArr.indexOf(r)>=0;});
var n=ctx.facetCount(function(p){return p.brand===g.brand;},'vendor');
h+='<li><button type="button" class="pes-bs-opt'+(sel?' selected':'')+'" data-kind="vendorgroup" data-qs="'+esc(qs)+'"><span>'+esc(g.brand)+'</span>'+(n>=0?'<span class="cnt">('+n+')</span>':'')+'</button></li>';
});
}else if(group.type==='tagfilter'){
group.values.forEach(function(g){
var qs=g.raw.map(function(r){return 'filter.p.tag='+encodeURIComponent(r);}).join('&');
var sel=g.rawl.some(function(r){return activeTagsArr.indexOf(r)>=0;});
var n=ctx.facetCount(function(p){
var hit=false;
for(var ri=0;ri<g.rawl.length;ri++){if(p.tags.indexOf(g.rawl[ri])>=0){hit=true;break;}}
return hit;
},'tag');
h+='<li><button type="button" class="pes-bs-opt'+(sel?' selected':'')+'" data-kind="tagfilter" data-qs="'+esc(qs)+'"><span>'+esc(g.label)+'</span>'+(n>=0?'<span class="cnt">('+n+')</span>':'')+'</button></li>';
});
}else if(group.type==='nav'){
group.values.forEach(function(g){
h+='<li><button type="button" class="pes-bs-opt pes-bs-nav" data-url="'+esc(g.url)+'"><span>'+esc(g.label)+'</span>'+(g.count>=0?'<span class="cnt">('+g.count+')</span>':'')+'</button></li>';
});
}else if(group.type==='vendor'){
group.values.forEach(function(vendor){
var n=ctx.facetCount(function(p){return p.v===vendor;},'vendor');
h+='<li><button type="button" class="pes-bs-opt" data-kind="vendor" data-value="'+esc(vendor)+'"><span>'+esc(vendor)+'</span>'+(n>=0?'<span class="cnt">('+n+')</span>':'')+'</button></li>';
});
}else if(group.type==='product_type'){
group.values.forEach(function(t){
var n=ctx.facetCount(function(p){return p.t===t;},'type');
h+='<li><button type="button" class="pes-bs-opt'+(staged.type===t?' selected':'')+'" data-kind="type" data-value="'+esc(t)+'"><span>'+esc(t)+'</span>'+(n>=0?'<span class="cnt">('+n+')</span>':'')+'</button></li>';
});
}else if(group.type==='price'){
group.values.forEach(function(pv){
var n=ctx.facetCount(function(p){
if(p.p===null)return false;
if(pv.gte&&p.p<parseFloat(pv.gte))return false;
if(pv.lte&&p.p>parseFloat(pv.lte))return false;
return true;
},'price');
h+='<li><button type="button" class="pes-bs-opt" data-kind="price" data-gte="'+(pv.gte||'')+'" data-lte="'+(pv.lte||'')+'"><span>'+esc(pv.label)+'</span>'+(n>=0?'<span class="cnt">('+n+')</span>':'')+'</button></li>';
});
h+='<li><div class="pes-bs-price-inputs">'
+'<input type="number" id="pes-bs-price-min" placeholder="$ Min" value="'+(ctx.activePriceGte||'')+'" aria-label="Minimum price">'
+'<span class="sep">–</span>'
+'<input type="number" id="pes-bs-price-max" placeholder="$ Max" value="'+(ctx.activePriceLte||'')+'" aria-label="Maximum price">'
+'</div></li>';
}else if(group.type==='availability'){
group.values.forEach(function(av){
var n=ctx.facetCount(function(p){return p.a;},'availability');
h+='<li><button type="button" class="pes-bs-opt'+(staged.avail?' selected':'')+'" data-kind="availability"><span>'+esc(av.label)+'</span>'+(n>=0?'<span class="cnt">('+n+')</span>':'')+'</button></li>';
});
}
h+='</ul></div>';
});
h+='</div>';
h+='<div class="pes-bs-foot">'
+'<button type="button" class="pes-bs-clear">Clear All</button>'
+'<button type="button" class="pes-bs-apply">Apply Filters</button>'
+'</div>';

var scrim=document.createElement('div');
scrim.className='pes-bs-scrim';scrim.id='pes-bs-scrim';
var sheet=document.createElement('div');
sheet.className='pes-bs-sheet';sheet.id='pes-bs-sheet';
sheet.setAttribute('role','dialog');
sheet.setAttribute('aria-modal','true');
sheet.setAttribute('aria-label','Filters');
sheet.innerHTML=h;
document.body.appendChild(scrim);
document.body.appendChild(sheet);

/* --- Behavior --- */
var openBtn=document.getElementById('pes-bs-open');
var lastFocus=null;

// Mark the price bucket matching current URL params
sheet.querySelectorAll('.pes-bs-opt[data-kind="price"]').forEach(function(btn){
var g=btn.getAttribute('data-gte'),l=btn.getAttribute('data-lte');
if((ctx.activePriceGte||'')===g&&(ctx.activePriceLte||'')===l&&(g||l))btn.classList.add('selected');
});

sheet.querySelectorAll('.pes-bs-opt').forEach(function(btn){
btn.addEventListener('click',function(){
var kind=btn.getAttribute('data-kind');
if(kind==='vendorgroup'||kind==='tagfilter'){
var qs=btn.getAttribute('data-qs');
var wasSelected=btn.classList.contains('selected');
sheet.querySelectorAll('.pes-bs-opt[data-kind="'+kind+'"]').forEach(function(b){b.classList.remove('selected');});
staged[kind==='vendorgroup'?'vendorQs':'tagQs']=wasSelected?null:qs;
if(!wasSelected)btn.classList.add('selected');
}else if(kind==='type'){
var val=btn.getAttribute('data-value');
var wasSelected=btn.classList.contains('selected');
sheet.querySelectorAll('.pes-bs-opt[data-kind="type"]').forEach(function(b){b.classList.remove('selected');});
staged.type=wasSelected?null:val;
if(!wasSelected)btn.classList.add('selected');
}else if(kind==='availability'){
staged.avail=!staged.avail;
btn.classList.toggle('selected',staged.avail);
}else if(kind==='price'){
var wasSelected=btn.classList.contains('selected');
sheet.querySelectorAll('.pes-bs-opt[data-kind="price"]').forEach(function(b){b.classList.remove('selected');});
var mn=sheet.querySelector('#pes-bs-price-min'),mx=sheet.querySelector('#pes-bs-price-max');
if(wasSelected){
if(mn)mn.value='';if(mx)mx.value='';
}else{
btn.classList.add('selected');
if(mn)mn.value=btn.getAttribute('data-gte');
if(mx)mx.value=btn.getAttribute('data-lte');
}
}
});
});
// Typing a custom price deselects bucket presets
['#pes-bs-price-min','#pes-bs-price-max'].forEach(function(sel){
var inp=sheet.querySelector(sel);
if(inp)inp.addEventListener('input',function(){
sheet.querySelectorAll('.pes-bs-opt[data-kind="price"]').forEach(function(b){b.classList.remove('selected');});
});
});
// Wattage/nav options navigate immediately
sheet.querySelectorAll('.pes-bs-nav').forEach(function(btn){
btn.addEventListener('click',function(){window.location.href=btn.getAttribute('data-url');});
});

function openSheet(){
lastFocus=document.activeElement;
scrim.classList.add('open');
sheet.classList.add('open');
document.body.classList.add('pes-bs-locked');
var first=sheet.querySelector('.pes-bs-close');
if(first)first.focus();
}
function closeSheet(){
scrim.classList.remove('open');
sheet.classList.remove('open');
document.body.classList.remove('pes-bs-locked');
if(lastFocus&&lastFocus.focus)lastFocus.focus();
else if(openBtn)openBtn.focus();
}
openBtn.addEventListener('click',openSheet);
scrim.addEventListener('click',closeSheet);
sheet.querySelector('.pes-bs-close').addEventListener('click',closeSheet);

// Esc + focus trap
document.addEventListener('keydown',function(e){
if(!sheet.classList.contains('open'))return;
if(e.key==='Escape'){closeSheet();return;}
if(e.key!=='Tab')return;
var focusable=sheet.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])');
if(!focusable.length)return;
var first=focusable[0],last=focusable[focusable.length-1];
if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
});

sheet.querySelector('.pes-bs-clear').addEventListener('click',function(){
window.location.href='/collections/'+handle;
});
sheet.querySelector('.pes-bs-apply').addEventListener('click',function(){
var u=new URL(window.location.href);
['filter.p.vendor','filter.p.tag','filter.p.product_type','filter.v.price.gte','filter.v.price.lte','filter.v.availability'].forEach(function(k){u.searchParams.delete(k);});
if(staged.vendorQs){new URLSearchParams(staged.vendorQs).forEach(function(v,k){u.searchParams.append(k,v);});}
if(staged.tagQs){new URLSearchParams(staged.tagQs).forEach(function(v,k){u.searchParams.append(k,v);});}
if(staged.type)u.searchParams.set('filter.p.product_type',staged.type);
var mn=sheet.querySelector('#pes-bs-price-min'),mx=sheet.querySelector('#pes-bs-price-max');
if(mn&&mn.value)u.searchParams.set('filter.v.price.gte',mn.value);
if(mx&&mx.value)u.searchParams.set('filter.v.price.lte',mx.value);
if(staged.avail)u.searchParams.set('filter.v.availability','1');
window.location.href=u.toString();
});
}

function clearParam(paramName){
var u=new URL(window.location.href);
u.searchParams.delete(paramName);
return u.toString();
}
function clearParams(paramNames){
var u=new URL(window.location.href);
paramNames.forEach(function(p){u.searchParams.delete(p);});
return u.toString();
}

/* ========== SUBNAV ACTIVE STATE ========== */
function fixSubnav(){
var items=document.querySelectorAll('.collection-subnavigation__item, .pes-subnav-item');
if(!items.length)return;
var path=window.location.pathname.toLowerCase();
items.forEach(function(item){
var link=item.querySelector('a');
if(link){
var href=link.getAttribute('href');
if(href&&path.indexOf(href.toLowerCase())>=0){item.classList.add('active');}
else{item.classList.remove('active');}
}
});
}

/* ========== BROWSE BUBBLE ========== */
function removeBrowseBubble(){
var b=document.querySelectorAll('[class*="browse-bubble"]');
b.forEach(function(e){e.style.display='none';});
}

/* ========== FORCE SIDEBAR VISIBLE (desktop only) ========== */
// ERR-025 follow-up: guard every write. Unconditional style.setProperty queues a
// mutation record even when unchanged, which re-triggered our own MutationObserver
// in an unbounded loop (main-thread spin on desktop PLP/search).
function setIf(el,prop,val){
if(el.style.getPropertyValue(prop)!==val)el.style.setProperty(prop,val,'important');
}
function forceSidebarVisible(){
if(window.innerWidth<=989){
// Mobile/tablet: never force the desktop sidebar open. Let the drawer CSS/JS (pes-collection-filters.js, breakpoint 989px) own visibility.
return;
}
var sf=document.querySelector('.cust-desktop-sortfilter');
if(sf){
setIf(sf,'display','block');
setIf(sf,'width','260px');
setIf(sf,'min-width','260px');
setIf(sf,'flex-shrink','0');
setIf(sf,'position','sticky');
setIf(sf,'top','80px');
setIf(sf,'max-height','calc(100vh - 100px)');
setIf(sf,'overflow-y','auto');
setIf(sf,'visibility','visible');
setIf(sf,'opacity','1');
}
var fc=findFacetsContainer();
if(fc){
setIf(fc,'display','flex');
setIf(fc,'gap','24px');
setIf(fc,'align-items','flex-start');
}
var grid=document.querySelector('.collection_main_grid');
if(grid){
setIf(grid,'flex','1');
setIf(grid,'min-width','0');
}
}

/* ========== INIT ========== */
function init(){
injectCSS();
forceSidebarVisible();
initSortDropdown();
fixSubnav();
removeBrowseBubble();
buildSidebar();
forceSidebarVisible();
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
else{init();}
setTimeout(function(){init();},500);
setTimeout(function(){init();},2000);
setTimeout(function(){init();},4000);
document.addEventListener('shopify:section:load',init);

// MutationObserver to keep sidebar visible if other scripts hide it
if(typeof MutationObserver!=='undefined'){
var mo=new MutationObserver(function(){forceSidebarVisible();});
if(document.body)mo.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class']});
}
})();
